var zeroPoint = {
  x: 0,
  y: 0,
  z: 0
};
var isNum = function (v) {
  return typeof v === 'number';
};
export { isNum, zeroPoint };